<!--begin::Quick Panel-->
<div
  id="kt_quick_panel"
  class="offcanvas pt-5 pb-10"
  [ngClass]="extrasQuickPanelOffcanvasDirectionCSSClass"
>
  <!--begin::Header-->
  <div
    class="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5"
  >
    <ul
      class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-primary flex-grow-1 px-10"
      role="tablist"
    >
      <li class="nav-item">
        <a
          class="nav-link cursor-pointer"
          data-toggle="tab"
          [ngClass]="getActiveCSSClasses('kt_quick_panel_notifications')"
          (click)="setActiveTabId('kt_quick_panel_notifications')"
          >Notifications</a
        >
      </li>
      <!--<li class="nav-item">
        <a
          class="nav-link cursor-pointer"
          [ngClass]="getActiveCSSClasses('kt_quick_panel_settings')"
          (click)="setActiveTabId('kt_quick_panel_settings')"
          data-toggle="tab"
          >Settings</a
        >
      </li>-->
    </ul>
    <div class="offcanvas-close mt-n1 pr-5">
      <a
        href="#"
        class="btn btn-xs btn-icon btn-light btn-hover-primary"
        id="kt_quick_panel_close"
      >
        <i class="ki ki-close icon-xs text-muted"></i>
      </a>
    </div>
  </div>
  <!--end::Header-->

  <!--begin::Content-->
  <div class="offcanvas-content px-10">
    <div class="tab-content">
      <!--begin::Tabpane-->
      <div
        class="tab-pane fade pt-2 pr-5 mr-n5"
        id="kt_quick_panel_notifications"
        [ngClass]="getActiveCSSClasses('kt_quick_panel_notifications')"
        role="tabpanel"
      >
        <!--begin::Nav-->
        <div class="navi navi-icon-circle navi-spacer-x-0">
          <!--begin::Item-->
          <a href="#" class="navi-item">
            <div class="navi-link rounded">
              <div class="symbol symbol-50 mr-3">
                <div class="symbol-label">
                  <i class="flaticon-bell text-success icon-lg"></i>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold font-size-lg">
                  5 new user generated report
                </div>
                <div class="text-muted">
                  Reports based on activities
                </div>
              </div>
            </div>
          </a>
          <!--end::Item-->
          <!--begin::Item-->
          <a href="#" class="navi-item">
            <div class="navi-link rounded">
              <div class="symbol symbol-50 mr-3">
                <div class="symbol-label">
                  <i class="flaticon2-box text-danger icon-lg"></i>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold font-size-lg">
                  2 new items submited
                </div>
                <div class="text-muted">
                  by Sergei Gorianin
                </div>
              </div>
            </div>
          </a>
          <!--end::Item-->
          <!--begin::Item-->
          <a href="#" class="navi-item">
            <div class="navi-link rounded">
              <div class="symbol symbol-50 mr-3">
                <div class="symbol-label">
                  <i class="flaticon-psd text-primary icon-lg"></i>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold font-size-lg">
                  79 files generated
                </div>
                <div class="text-muted">
                  Reports based on recent activities
                </div>
              </div>
            </div>
          </a>
          <!--end::Item-->

          <!--begin::Item-->
          <a href="#" class="navi-item">
            <div class="navi-link rounded">
              <div class="symbol symbol-50 mr-3">
                <div class="symbol-label">
                  <i class="flaticon-notepad text-primary icon-lg"></i>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold font-size-lg">
                  Avarage 1 study and 2 data objects per author
                </div>
                <div class="text-muted">
                  Most posted 3 time(s)
                </div>
              </div>
            </div>
          </a>
          <!--end::Item-->
          <!--begin::Item-->
          <a href="#" class="navi-item">
            <div class="navi-link rounded">
              <div class="symbol symbol-50 mr-3">
                <div class="symbol-label">
                  <i class="flaticon-users-1 text-warning icon-lg"></i>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold font-size-lg">
                  16 collaborators joined last week
                </div>
                <div class="text-muted">
                  9 clinical researchers
                </div>
              </div>
            </div>
          </a>
          <!--end::Item-->
          <!--begin::Item-->
          <a href="#" class="navi-item">
            <div class="navi-link rounded">
              <div class="symbol symbol-50 mr-3">
                <div class="symbol-label">
                  <i class="flaticon2-download text-success icon-lg"></i>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold font-size-lg">
                  2.8 GB - total data objects size
                </div>
                <div class="text-muted">
                  Mostly PDF and JSON files
                </div>
              </div>
            </div>
          </a>
          <!--end::Item-->
        </div>
        <!--end::Nav-->
      </div>
      <!--end::Tabpane-->

      <!--begin::Tabpane-->
      <div
        class="tab-pane fade pt-3 pr-5 mr-n5"
        id="kt_quick_panel_settings"
        [ngClass]="getActiveCSSClasses('kt_quick_panel_settings')"
        role="tabpanel"
      >
        <form class="form">
          <!--begin::Section-->
          <div>
            <h5 class="font-weight-bold mb-3">Customer Care</h5>
            <div class="form-group mb-0 row align-items-center">
              <label class="col-8 col-form-label">Enable Notifications:</label>
              <div class="col-4 d-flex justify-content-end">
                <span class="switch switch-success switch-sm">
                  <label>
                    <input type="checkbox" checked="checked" name="select" />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
            <div class="form-group mb-0 row align-items-center">
              <label class="col-8 col-form-label">Enable Case Tracking:</label>
              <div class="col-4 d-flex justify-content-end">
                <span class="switch switch-success switch-sm">
                  <label>
                    <input type="checkbox" name="quick_panel_notifications_2" />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
            <div class="form-group mb-0 row align-items-center">
              <label class="col-8 col-form-label">Support Portal:</label>
              <div class="col-4 d-flex justify-content-end">
                <span class="switch switch-success switch-sm">
                  <label>
                    <input type="checkbox" checked="checked" name="select" />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
          </div>
          <!--end::Section-->

          <div class="separator separator-dashed my-6"></div>

          <!--begin::Section-->
          <div class="pt-2">
            <h5 class="font-weight-bold mb-3">Reports</h5>
            <div class="form-group mb-0 row align-items-center">
              <label class="col-8 col-form-label">Generate Reports:</label>
              <div class="col-4 d-flex justify-content-end">
                <span class="switch switch-sm switch-danger">
                  <label>
                    <input type="checkbox" checked="checked" name="select" />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
            <div class="form-group mb-0 row align-items-center">
              <label class="col-8 col-form-label">Enable Report Export:</label>
              <div class="col-4 d-flex justify-content-end">
                <span class="switch switch-sm switch-danger">
                  <label>
                    <input type="checkbox" name="select" />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
            <div class="form-group mb-0 row align-items-center">
              <label class="col-8 col-form-label">Allow Data Collection:</label>
              <div class="col-4 d-flex justify-content-end">
                <span class="switch switch-sm switch-danger">
                  <label>
                    <input type="checkbox" checked="checked" name="select" />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
          </div>
          <!--end::Section-->
        </form>
      </div>
      <!--end::Tabpane-->
    </div>
  </div>
  <!--end::Content-->
</div>
<!--end::Quick Panel-->
